import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { StarRating } from "@/components/common/StarRating";
import { SectionHeading } from "@/components/common/SectionHeading";
import { useTestimonials } from "@/hooks/useCatalog";

export function ReviewsCarousel() {
  const { data } = useTestimonials();
  const reviews = data?.testimonials || [];
  const [i, setI] = useState(0);

  useEffect(() => {
    if (!reviews.length) return;
    const t = setInterval(() => setI((p) => (p + 1) % reviews.length), 6000);
    return () => clearInterval(t);
  }, [reviews.length]);

  if (!reviews.length) return null;
  const r = reviews[i];

  return (
    <section className="bg-cream py-16 lg:py-24" data-testid="reviews-section">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <SectionHeading eyebrow="Kind Words" title="What Our Clients Say" />
        <div className="relative mt-12 text-center">
          <Quote className="mx-auto h-9 w-9 text-gold/50" />
          <StarRating rating={r.rating} size={16} className="mt-5 justify-center" />
          <p key={i} className="mx-auto mt-6 max-w-2xl animate-fade-in font-serif text-2xl font-light leading-snug text-ink sm:text-3xl">
            “{r.text}”
          </p>
          <p className="mt-6 text-sm font-semibold uppercase tracking-widest text-ink">{r.name}</p>
          <p className="text-xs uppercase tracking-widest text-muted-foreground">{r.location}</p>

          <div className="mt-8 flex items-center justify-center gap-3">
            <button
              onClick={() => setI((p) => (p - 1 + reviews.length) % reviews.length)}
              aria-label="Previous review"
              className="grid h-10 w-10 place-items-center rounded-full border border-border text-ink transition-colors hover:border-gold hover:text-gold"
            >
              <ChevronLeft size={18} />
            </button>
            <div className="flex gap-1.5">
              {reviews.map((r, idx) => (
                <button
                  key={r.name || idx}
                  onClick={() => setI(idx)}
                  aria-label={`Go to review ${idx + 1}`}
                  className={`h-1.5 rounded-full transition-all ${idx === i ? "w-6 bg-gold" : "w-1.5 bg-border"}`}
                />
              ))}
            </div>
            <button
              onClick={() => setI((p) => (p + 1) % reviews.length)}
              aria-label="Next review"
              className="grid h-10 w-10 place-items-center rounded-full border border-border text-ink transition-colors hover:border-gold hover:text-gold"
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
